(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.delCardsInit === 'true') return;
    section.dataset.delCardsInit = 'true';

    const openButtons = section.querySelectorAll('[data-card-open]');
    // Move all modals to <body> level to escape any parent that creates a containing block
    // (transform/filter/will-change on ancestors breaks position:fixed).
    const modalsList = Array.from(section.querySelectorAll('[data-card-modal]'));
    modalsList.forEach((m) => {
      if (m.parentElement !== document.body) {
        document.body.appendChild(m);
      }
    });
    const modals = modalsList;
    let lastFocused = null;

    function openModal(id) {
      const modal = modals.find((m) => m.dataset.cardModal === id);
      if (!modal) return;
      lastFocused = document.activeElement;
      modal.hidden = false;
      const closeBtn = modal.querySelector('.del-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeAll() {
      modals.forEach((m) => (m.hidden = true));
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function openByDepartment(deptSlug) {
      // Try exact match first, then match against space-separated aliases (~=)
      let item = section.querySelector('.del-cards__item[data-delegate="' + deptSlug + '"]');
      if (!item) {
        item = section.querySelector('.del-cards__item[data-delegate~="' + deptSlug + '"]');
      }
      if (!item) return false;
      const trigger = item.querySelector('[data-card-open]');
      if (!trigger) return false;
      openModal(trigger.dataset.cardOpen);
      return true;
    }

    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => openModal(btn.dataset.cardOpen));
    });

    modals.forEach((modal) => {
      modal.querySelectorAll('[data-card-close]').forEach((el) => {
        el.addEventListener('click', closeAll);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const anyOpen = modals.some((m) => !m.hidden);
      if (anyOpen) closeAll();
    });

    // Expose for the map section so clicking a region opens the matching modal
    window.MNDelegations = window.MNDelegations || {};
    window.MNDelegations.openByDepartment = openByDepartment;
  }

  function bootAll() {
    document.querySelectorAll('.del-cards').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.del-cards');
    if (section) initSection(section);
  });
})();
